import React, { PropsWithChildren } from 'react';

import { TopNavigation, SideNavigation, PrivacyBanner, PrivacyFooter, EnvironmentBanner } from '.';

function Dashboard({ children }: PropsWithChildren<{}>) {
    return (
        <React.Fragment>
            {/* Header height varies (it wraps on narrow viewports, e.g. WebView2), so the body takes the rest */}
            <div className="flex h-screen flex-col">
                <TopNavigation />
                <div className="flex min-h-0 flex-1 flex-col">
                    <main className="relative flex min-h-0 flex-1">
                        <SideNavigation />

                        {/* Content */}
                        <div className="relative flex flex-1 flex-col overflow-y-auto bg-white px-4 py-3">
                            {children}
                        </div>

                        {/* Anchored to main (which does not scroll), so it always sits just below the header */}
                        <EnvironmentBanner placement="below-nav" />
                    </main>

                    {/* Full width, below both the side navigation and the content */}
                    <PrivacyFooter />
                </div>
            </div>

            <PrivacyBanner />
        </React.Fragment>
    );
}

export default Dashboard;
